import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// TODO: Replace deprecated i18next-xhr-backend with i18next-http-backend
// 1. Update package.json: "i18next-http-backend": "^2.x.x"
// 2. Change import: import Backend from "i18next-http-backend";
// 3. Run: npm install
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import packageJson from "../../package.json"; // Import the package.json as a module

i18n.use(initReactI18next)
    .use(Backend)
    .use(LanguageDetector)
    .init({
        lng: localStorage.getItem("i18nextLng") || "vn",
        fallbackLng: localStorage.getItem("i18nextLng") || "vn",
        debug: false,
        defaultNS: "translation",
        backend: {
            loadPath: `/locales/{{lng}}/translation.json?v=${packageJson?.version}`,
        },
        interpolation: {
            escapeValue: true,
        },
        react: {
            useSuspense: false,
        },
    });

export { i18n };
